import { KeycloakParsedToken } from '../types/token';

export const parseKeycloakToken = (tokenParsed: any): KeycloakParsedToken => {
    return {
        exp: tokenParsed.exp,
        iat: tokenParsed.iat,
        jti: tokenParsed.jti,
        iss: tokenParsed.iss,
        aud: tokenParsed.aud,
        sub: tokenParsed.sub,
        realm_access: tokenParsed.realm_access,
        resource_access: tokenParsed.resource_access,
        preferred_username: tokenParsed.preferred_username,
        email: tokenParsed.email,
        os_id: tokenParsed.os_id,
        os_password: tokenParsed.os_password,
        os_project: tokenParsed.os_project,
        os_ready: typeof tokenParsed.os_ready === 'boolean' ? tokenParsed.os_ready : false,
        os_token: tokenParsed.os_token,
        os_token_expires_at: tokenParsed.os_token_expires_at,
    };
};